import styles from './index.module.css';
import { Spin } from 'antd';
const Mask = () => {
    const element = <div className={styles.mask}>
        <Spin className={styles.spin} size="large" />
    </div>
    return element
}
export default Mask